import { Route, BrowserRouter as Router, Routes, Link } from "react-router-dom";
import "./App.css";
import { Cta, Footer, Header, JobView, CityJobs, SearchView } from "./components";

import { Home, Jobs, About, Terms, NotFound, Saved } from "./pages";
import { feature } from "./utils/features";
import { ScrollTop } from "./utils";

function App() {
  return (
    <>
      <Router>

        <ScrollTop>
          {/* Printing a job page prints just the job (no header, banner or footer). */}
          <div className="print:hidden">
            <Header />
          </div>

          <Routes>

            
            <Route exact path="/about" element={<About />}></Route>

            <Route exact path="/" element={<Home />}></Route>

            <Route exact path="/jobs" element={<Jobs />}></Route>

            <Route exact path="/jobs/:btnId" element={<JobView  />}></Route>
            
            <Route exact path="/jobs/city/:city" element={<CityJobs  />}></Route>

            <Route exact path="/search/:location/:title" element={<SearchView  />}></Route>
            <Route exact path="/search/*/*" element={<NotFound  />}></Route>

            <Route exact path="/terms-and-conditions" element={<Terms />}></Route>

            {feature("savedJobs") && <Route exact path="/saved" element={<Saved />}></Route>}

            <Route exact path="*" element={<NotFound />}></Route>

          </Routes>

          <div className="print:hidden">
            <Cta />
            <Footer />
          </div>
        </ScrollTop>

      </Router>
    </>
  );
}

export default App;
